module.exports = "<div uib-tooltip=\"{{vm.mssTooltipMessage}}\"\n     tooltip-class=\"message-alert-tooltip\"\n     tooltip-enable=\"vm.isMssTooltipDisplay\"\n     tooltip-is-open=\"vm.isMssTooltipDisplay\"\n     tooltip-placement=\"{{vm.mssTooltipPlace}}\">\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/integration-settings/components/common/message-alert-tooltip.html
// module id = 279
// module chunks = 0